<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon color="#277FAF" size="20">mdi-information</v-icon>
      </v-btn>
    </template>
    <transition :duration="150">
      <v-card class="px-10 py-15">
        <CloseModalBtn :close-modal="closeModal"/>
        <div class="fw500 f24 text-center">
          <v-icon color="#277FAF" size="20">mdi-information</v-icon>
          {{ item.title }}
        </div>
        <template v-if="item.info">
          <div v-for="(i, j) in item.info" :key="j">
            <BaseInput
              view
              :label="i.name"
              :view-value="i.value"
              bold
              class-label="primary-text f14 mb-2 mt-5"
              class_view-value="f14"
            />
          </div>
        </template>
      </v-card>
    </transition>
  </v-dialog>
</template>

<script>
import CloseModalBtn from "../../CloseModalBtn";
import BaseInput from "../../base/BaseInput";

export default {
  name: "FinanceInvoiceItemModal",
  components: {BaseInput, CloseModalBtn},
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
}
</script>
